var render = function render(){var _vm=this,_c=_vm._self._c;return _c('eg-b-container',[_c('eg-b-row',[_c('eg-b-col',[(_vm.isSessionExpired)?_c('eg-b-alert',{attrs:{"variant":"warning","show":""}},[_vm._v(_vm._s(_vm.$t("auth.sessionExpired")))]):_vm._e(),_c('login-form')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }